export const DATEPICKER_FORMAT = "MM-DD-YYYY";
export const TIME_WITH_TIME_ZONE_FORMAT = "dddd, M/D h:mm A";
